import { render, staticRenderFns } from "./Next.vue?vue&type=template&id=190185a0&scoped=true&lang=pug&"
import script from "./Next.vue?vue&type=script&lang=js&"
export * from "./Next.vue?vue&type=script&lang=js&"
import style0 from "./Next.scss?vue&type=style&index=0&id=190185a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190185a0",
  null
  
)

export default component.exports